import { useLiteStorefront } from '@hooks/use-lite-storefront';
import { useAppSelector } from '@redux/hooks';
import { selectIsMobile } from '@redux/viewport/selectors';
import { Link } from '@tkww/orion-web-ds-action';
import { Icon } from '@tkww/orion-web-ds-graphic';
import compact from 'lodash/compact';
import React from 'react';
import type { DecoratedAddress } from 'types/vendor';
import Styles from './static-map.scss';

type StaticMapProps = {
	address: DecoratedAddress;
};

const zoom = '13';
const type = 'roadmap';
const googlemapsApiKey = process.env.GOOGLEMAPS_API_KEY;

export const StaticMap: React.FC<StaticMapProps> = ({ address }) => {
	const isMobile = useAppSelector(selectIsMobile);
	const isLiteStorefront = useLiteStorefront();
	const size = `600x${isMobile ? (!isLiteStorefront ? '350' : '200') : '245'}`;

	const formattedAddress = compact([
		address.isPublic ? address.address : '',
		address.city,
		address.state,
	]).join(', ');

	const encodedAddress = encodeURIComponent(formattedAddress);
	const staticMapSrc = `https://maps.googleapis.com/maps/api/staticmap?center=${encodedAddress}&zoom=${zoom}&scale=2&size=${size}&maptype=${type}&format=png&key=${googlemapsApiKey}&markers=color:red%7C${encodedAddress}`;
	const linkRedirectMap = `https://maps.google.com/?q=${encodedAddress}`;

	return (
		<>
			<img src={staticMapSrc} alt={formattedAddress} loading="lazy" />
			<div className={Styles.location}>
				<Icon
					name="pin"
					size={!isLiteStorefront ? 'md' : 'sm'}
					aria-hidden={true}
					aria-label={undefined}
				/>
				<span>{formattedAddress}</span>
			</div>
			<Link
				href={linkRedirectMap}
				styleType="secondary"
				size="md"
				target="_blank"
			>
				Open map
			</Link>
		</>
	);
};
